import moment from 'moment';
import {ref} from "@modules/vue";

export const formatDate = (date: string) => moment(date).format('DD.MM.YYYY');
export const formatDateTime = (date: string) => moment(date).format('DD.MM.YYYY HH:mm');
export const datePartISO = (date: Date) => date.toISOString().split('T')[0];
